import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "stickyBar" }
const _hoisted_2 = { class: "list_container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "group_item" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "group_name" }
const _hoisted_8 = { key: 0 }

import { emitWithPreviewCheck, GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, onMounted, computed, onBeforeMount, watch, nextTick } from 'vue'
import GamePopup from '@/view/game/gamePopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'groupList',
  props: {
    listData: {},
    itemData: {}
  },
  emits: ['goToGamePanel'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = __props
const localActiveItem = ref<string | number>('')
const gameListRef = ref()
const showGameList = ref(false)
const emits = __emit
const activeItem = computed({
    get: () => localActiveItem.value || props.listData[0]?.id || '',
    set: (val) => {
        localActiveItem.value = val
    }
})
const goToGamePannel = (id: number | string, groupType: number) => {
    let data = {
        id: id,
        groupType: groupType
    }
    emitWithPreviewCheck(emits, 'goToGamePanel', data)
}

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = async (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
    await nextTick()
    gameListRef.value?.selectGroup(item)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}

__expose({
    setActiveItem,
    setActiopFunGroup
})

onBeforeMount(() => {
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (setActiopFunGroup(item)),
            class: "centerAlign"
          }, [
            _createElementVNode("div", {
              class: "groupData",
              onClick: ($event: any) => (goToGamePannel(item.id, item.groupType))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.customIcon,
                  alt: ""
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(item.name)), 1)
            ], 8, _hoisted_4)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    (showGameList.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(GamePopup, {
            ref_key: "gameListRef",
            ref: gameListRef
          }, null, 512)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})